import DigitalTryIn from '@/pages/digitalTryIn'
import ShadeGuideAi from '@/pages/getRecipe/shadeGuide/ShadeGuideAi'
import FullLayeringRoutes from '@/routes/FullLayeringRoutes'
import FullMonolithicRoutes from '@/routes/FullMonolithicRoutes'
import GingivaRoutes from '@/routes/GingivaRoutes'
import MicroLayeringRoutes from '@/routes/MicroLayeringRoutes'
import PfmCrownRoutes from '@/routes/PfmCrownRoutes'

// import StainingStudioRoutes from '@/routes/StainingStudioRoutes'

import AllInOne from '../pages/getRecipe/allInOne'
import MatisseLiteRoutes from './MatisseLiteRoutes'
import ModelMakingRoutes from './ModelMakingRoutes'
import StainingStudioRoutes from './StainingStudioRoutes'

export interface RouteConfig {
  path: string
  element: React.ComponentType
  children?: RouteConfig[]
}

export const routes: RouteConfig[] = [
  {
    path: '/all-in-one',
    element: AllInOne,
  },
  {
    path: '/shade-guide-ai',
    element: ShadeGuideAi,
  },
  {
    path: '/full-layering/*',
    element: FullLayeringRoutes,
  },
  {
    path: '/full-monolithic/*',
    element: FullMonolithicRoutes,
  },
  {
    path: '/gingiva/*',
    element: GingivaRoutes,
  },
  {
    path: '/micro-layering/*',
    element: MicroLayeringRoutes,
  },
  {
    path: '/pfm-crown/*',
    element: PfmCrownRoutes,
  },
  {
    path: '/digital-try-in',
    element: DigitalTryIn,
  },
  {
    path: '/staining-studio/*',
    element: StainingStudioRoutes,
  },
  {
    path: '/model-making/*',
    element: ModelMakingRoutes,
  },
  {
    path: '/matisse-lite/*',
    element: MatisseLiteRoutes,
  },
]
